module.exports = {
    tag: 'vetronius',
    quality: 1.0,
    toughness: 5,
    willpower: 3,
    strength: 2,
    mana: 1
};